module.exports = __webpack_public_path__ + "img/siguenos-rrss-KB-web-entradas-512x301_eus.c88bba70.jpg";